import {
	HomeIcon,
	CalendarDaysIcon,
	DocumentTextIcon,
	UserIcon,
	ClipboardDocumentListIcon,
	BanknotesIcon,
	CurrencyDollarIcon,
} from '@heroicons/react/24/outline';
import { USER_ROLE } from '../../types/auth';
import { NavigationConfig } from './types';

export const staffNav: NavigationConfig = [
	{
		items: [
			{
				icon: HomeIcon,
				label: 'Dashboard',
				path: '/staff/dashboard',
				roles: [USER_ROLE.STAFF],
			},
			{
				icon: CalendarDaysIcon,
				label: 'Bookings',
				path: '/staff/bookings',
				roles: [USER_ROLE.STAFF],
			},
			{
				icon: DocumentTextIcon,
				label: 'TCR',
				path: '/staff/tcr',
				roles: [USER_ROLE.STAFF],
			},
		],
	},
	{
		title: 'Earnings',
		items: [
			{
				icon: CurrencyDollarIcon,
				label: 'My Earnings',
				path: '/staff/earnings',
				roles: [USER_ROLE.STAFF],
			},
		],
	},
	{
		title: 'Account',
		items: [
			{
				icon: BanknotesIcon,
				label: 'Payment Setup',
				path: '/staff/payment-setup',
				roles: [USER_ROLE.STAFF],
			},
			{
				icon: UserIcon,
				label: 'My Profile',
				path: '/staff/profile',
				roles: [USER_ROLE.STAFF],
			},
			{
				icon: ClipboardDocumentListIcon,
				label: 'Agreements',
				path: '/staff/agreements',
				roles: [USER_ROLE.STAFF],
			},
		],
	},
];
